import { createFirehoseMessageRouter } from './firehose-message-router.js';
import type { FirehoseJsonMessage } from './firehose-message-router.js';
import type { FirehoseMessageDeps } from './firehose-message-deps.js';
import { handlePreviewEnvironmentLogsViewerOpen } from './handlers/preview-environment-logs-viewer-open.js';
import { handlePreviewEnvironmentLogsViewerClose } from './handlers/preview-environment-logs-viewer-close.js';
import { handleProxyMessage } from './handlers/proxy-message.js';
import { handleFirehoseIdentified } from './handlers/identified.js';

const router = createFirehoseMessageRouter();

router.register('identified', handleFirehoseIdentified);
router.register('log_viewer_open', handlePreviewEnvironmentLogsViewerOpen);
router.register('log_viewer_close', handlePreviewEnvironmentLogsViewerClose);
router.register('proxy', handleProxyMessage);

export function dispatchFirehoseJsonMessage(msg: FirehoseJsonMessage, deps: FirehoseMessageDeps): void {
  router.dispatch(msg, deps);
}

export type { FirehoseMessageDeps } from './firehose-message-deps.js';
export type { FirehoseJsonMessage } from './firehose-message-router.js';
